/* eslint-disable etc/no-commented-out-code */
import { logger as LOG } from '@sweetgreen/garnish';

const nativeName = 'Mixpanel RN';
const webName = 'Mixpanel Web';
const nativeLibName = 'Mixpanel RN Lib';
const webLibName = 'Mixpanel Web Lib';
const mockName = 'Mixpanel Mock';

export const nativeLogger = LOG.extend(nativeName);
export const webLogger = LOG.extend(webName);
export const nativeLibLogger = LOG.extend(nativeLibName);
export const webLibLogger = LOG.extend(webLibName);
export const mockLogger = LOG.extend(mockName);

// LOG.enable(nativeName);
// LOG.enable(webName);
// LOG.enable(nativeLibName);
// LOG.enable(webLibName);
// LOG.enable(mockName);
